import { anchorToolbarButton } from "./plugins/element/anchors/anchorToolbarButton.js";
import { headingOneToolbarButton, headingOneNumberedToolbarButton, headingTwoToolbarButton, headingTwoNumberedToolbarButton, headingThreeToolbarButton, headingThreeNumberedToolbarButton, headingFourToolbarButton, headingFourNumberedToolbarButton, headingFiveToolbarButton, headingFiveNumberedToolbarButton, headingSixToolbarButton, headingSixNumberedToolbarButton } from "./plugins/element/headings/headingToolbarButtons.js";
import { horizontalRuleToolbarButton } from "./plugins/element/horizonalRules/horizontalRuleToolbarButton.js";
import { orderedListToolbarButton, unorderedListToolbarButton } from "./plugins/element/lists/listToolbarButtons.js";
import { paragraphToolbarButton, paragraphNumberedToolbarButton } from "./plugins/element/paragraphs/paragraphToolbarButtons.js";
import { scrollTargetToolbarButton } from "./plugins/element/scrollTargets/scrollTargetToolbarButton.js";
import { tableToolbarButton } from "./plugins/element/tables/tableToolbarButtons.js";
import { boldToolbarButton } from "./plugins/text/bold/boldToolbarButton.js";
import { codeToolbarButton } from "./plugins/text/code/codeToolbarButton.js";
import { highlightToolbarButton } from "./plugins/text/highlight/highlightToolbarButton.js";
import { italicToolbarButton } from "./plugins/text/italic/italicToolbarButton.js";
import { strikeThroughToolbarButton } from "./plugins/text/strikeThrough/strikeThroughToolbarButton.js";
import { underlineToolbarButton } from "./plugins/text/underline/underlineToolbarButton.js";
import { alignStartButton, alignEndButton, alignCenterButton, alignJustifyButton } from "./plugins/attributes/alignment/alignButton.js";
var RichEditor;
((RichEditor2) => {
  RichEditor2.buttons = {
    anchor: anchorToolbarButton,
    headingOne: headingOneToolbarButton,
    headingOneNumbered: headingOneNumberedToolbarButton,
    headingTwo: headingTwoToolbarButton,
    headingTwoNumbered: headingTwoNumberedToolbarButton,
    headingThree: headingThreeToolbarButton,
    headingThreeNumbered: headingThreeNumberedToolbarButton,
    headingFour: headingFourToolbarButton,
    headingFourNumbered: headingFourNumberedToolbarButton,
    headingFive: headingFiveToolbarButton,
    headingFiveNumbered: headingFiveNumberedToolbarButton,
    headingSix: headingSixToolbarButton,
    headingSixNumbered: headingSixNumberedToolbarButton,
    horizontalRule: horizontalRuleToolbarButton,
    orderedList: orderedListToolbarButton,
    paragraph: paragraphToolbarButton,
    paragraphNumbered: paragraphNumberedToolbarButton,
    scrollTarget: scrollTargetToolbarButton,
    unorderedList: unorderedListToolbarButton,
    table: tableToolbarButton,
    bold: boldToolbarButton,
    code: codeToolbarButton,
    highlight: highlightToolbarButton,
    italic: italicToolbarButton,
    strikeThrough: strikeThroughToolbarButton,
    underline: underlineToolbarButton,
    alignStart: alignStartButton,
    alignEnd: alignEndButton,
    alignCenter: alignCenterButton,
    alignJustify: alignJustifyButton
  };
})(RichEditor || (RichEditor = {}));
export {
  RichEditor
};
//# sourceMappingURL=RichEditor.js.map
